










import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzTitle from "../cz/CzTitle.vue";

@Component({ components: { CzCard, CzTitle } })
export default class ProgramPanel extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) summary!: string;
}
